"use strict";

(function () {
  function setupLottieInteractivity(playerId) {
    document.getElementById(playerId).addEventListener('ready', function () {
      LottieInteractivity.create({
        player: '#' + playerId,
        mode: 'scroll',
        actions: [{
          visibility: [0.25, 1.0],
          type: 'playOnce'
        }]
      });
    });
  }
  setupLottieInteractivity('case_study_resource__lottie_1');
  setupLottieInteractivity('case_study_resource__lottie_2');
  setupLottieInteractivity('case_study_resource__lottie_3');
  var setControls = function setControls(el) {
    if (window.innerWidth < 900) return;
    var isHideControls = el.slides.length < 2;
    if (isHideControls) {
      el.params.pagination.clickable = false;
      el.params.scrollbar.hide = true;
    }
  };
  new Swiper('[data-feature-swiper-slider]', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 1,
    centeredSlides: false,
    spaceBetween: 28,
    grabCursor: true,
    autoplay: {
      enabled: true,
      delay: 5000
    },
    keyboard: {
      enabled: true
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        centeredSlides: true
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit(el) {
        var delay = parseFloat(el.el.dataset.swiperAutoplay);
        el.params.autoplay.delay = !!delay && delay;
        el.params.autoplay.enabled = !!delay;
      },
      resize: function resize(el) {
        return setControls(el);
      },
      afterInit: function afterInit(el) {
        return setControls(el);
      }
    }
  });

  /*  var swiper = new Swiper(".mySwiper", {
      slidesPerView: 4,
      spaceBetween: 30,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });*/
})();